import { useNavigate, useParams } from "react-router-dom";

import TituloForm, { ITituloFormProps } from "./TituloForm";

export interface ITituloAPagarScreenProps extends ITituloFormProps {
}

export default function TituloAPagarScreen({ onCancelar, onSalvarSucesso, codigo : codParam, ...rest }: ITituloAPagarScreenProps): JSX.Element {
    const navigate = useNavigate();

    const { codigo : codRotaString } = useParams();
    const codRota = Number.parseInt(codRotaString ?? "");

    const codigo = isNaN(codRota) || codRota <= 0 ? codParam : codRota;

    const isAlteracao = (codigo ?? 0) > 0;
    
    return (
        <TituloForm
            {...rest}
            codigo={codigo}
            isAReceber={isAlteracao ? undefined : false}
            onCancelar={onCancelar ?? ((ev) => navigate(-1))}
            onSalvarSucesso={(...rest) => {
                onSalvarSucesso?.(...rest);
                (onCancelar ?? ((ev) => navigate(-1)))?.({} as any);
            }}
        />
    );
}